<template>
  <b-row>
    <b-col v-if="isLoading">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else>
      <b-row v-if="item">
        <b-col>
          <router-link v-if="prevRoute && prevRoute.name === 'TimetableDashboard'" :to="{ name: 'TimetableDashboard' }" class="btn btn-default float-right">
            <span v-if="!mobileView">{{$t('buttons.backToCRM')}}</span>
            <i v-else class="far fa-arrow-alt-left"></i>
          </router-link>
          <router-link v-else :to="{ name: 'EXCMCorrespondenceThreadsList' }" class="btn btn-default float-right">{{$t('buttons.backToList')}}</router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <div class="card-body">
              <b-row v-if="item">
                <b-col>
                  <p class="m-0"><b>{{$t('views.excmcorrespondence.list.messageDateTime')}}:</b><span v-if="item.messageDateTime"> {{ $moment(item.messageDateTime).format('YYYY-MM-DD HH:mm:ss') }}</span></p>
                  <p class="m-0"><b>{{$t('views.excmcorrespondence.list.subject')}}:</b> {{ item.subject }}</p>
                  <p class="m-0"><b>{{$t('views.excmcorrespondence.list.messageQuantity')}}:</b> {{ item.messages.length }}</p>
                  <p class="m-0"><b>{{$t('views.excmcorrespondence.list.idContractor')}}:</b>
                    <router-link v-if="item.idContractor && item.idContractor.isCompany === 0" :to="{name: 'UserDataShow', params: { id: item.idContractor['@id'] }}">
                      {{ item.idContractor.name }} {{ item.idContractor.surname }}
                    </router-link>
                    <router-link v-else-if="item.idContractor" :to="{name: 'FirmShow', params: { id: item.idContractor['@id'] }}">
                      {{ item.idContractor.firmname1 === '' ? item.idContractor.fullName : item.idContractor.firmname1 }}
                    </router-link>
                    <span @click="showSetContractorModal()" style="cursor: pointer">
                      <i style="color: #28a745" class="fa fa-edit"></i>
                    </span>
                  </p>
                </b-col>
              </b-row>
            </div>
          </b-card>
          <b-row class="mt-2">
            <b-col cols="12">
              <h6>{{$t('views.excmcorrespondence.show.messages')}}:</h6>
            </b-col>
            <b-col cols="12" v-for="(threadMessage, threadMessageIndex) in item.messages" v-bind:key="'threadMessage-' + threadMessageIndex">
              <div class="card card-stats">
                <div class="card-body">
                  <div class="card-footer">
                    <b-row>
                      <b-col>
                        <p class="m-0"><b>{{$t('views.excmcyclictask.list.dateFrom')}}: </b>{{threadMessage.messageFrom}} <span v-if="threadMessage.messageFromIdUserData">
                          <router-link v-if="threadMessage.messageFromIdUserData.isCompany === 0" :to="{name: 'UserDataShow', params: { id: threadMessage.messageFromIdUserData['@id'] }}">
                            <i style="color: #28a745" class="fa fa-arrow-right"></i>
                          </router-link>
                          <router-link v-else :to="{name: 'FirmShow', params: { id: threadMessage.messageFromIdUserData['@id'] }}">
                            <i style="color: #28a745" class="fa fa-arrow-right"></i>
                          </router-link>
                          <b-btn variant="primary" size="sm" class="ml-2" v-if="threadMessage.messageFromIdUserData" @click="createMessage(threadMessage.messageFromIdUserData, item.idSenderType)">
                            <i class="fa fa-paper-plane mr-2"></i>{{$t('buttons.sendMessage')}}
                          </b-btn>
                          </span>
                        </p>
                        <p class="m-0"><b>{{$t('views.excmcyclictask.list.dateTo')}}: </b>{{threadMessage.messageTo}} <span v-if="threadMessage.messageToIdUserData">
                          <router-link v-if="threadMessage.messageToIdUserData.isCompany === 0" :to="{name: 'UserDataShow', params: { id: threadMessage.messageToIdUserData['@id'] }}">
                            <i style="color: #28a745" class="fa fa-arrow-right"></i>
                          </router-link>
                          <router-link v-else :to="{name: 'FirmShow', params: { id: threadMessage.messageToIdUserData['@id'] }}">
                            <i style="color: #28a745" class="fa fa-arrow-right"></i>
                          </router-link>
                          <b-btn variant="primary" size="sm" class="ml-2" v-if="threadMessage.messageToIdUserData" @click="createMessage(threadMessage.messageToIdUserData, item.idSenderType)">
                            <i class="fa fa-paper-plane mr-2"></i>{{$t('buttons.sendMessage')}}
                          </b-btn>
                        </span>
                        </p>
                        <p class="m-0"><b>{{$t('views.excmcorrespondence.list.subject')}}: </b>{{threadMessage.subject}}</p>
                        <p class="m-0"><b>{{$t('views.excmdevicestate.list.table.date')}}: </b>{{$moment(threadMessage.messageDateTime).format('YYYY-MM-DD HH:mm:ss')}}</p>
                      </b-col>
                      <b-col class="text-right">
                        <div v-if="ableToCreateCase" style="display: inline-block" v-b-tooltip.hover :title="!item.idContractor ? $t('views.excmcorrespondence.show.noContractor') : (item.idContractor.isCompany === 0 ? $t('views.excmcorrespondence.show.contractorIsNotCompany') : '')">
                          <b-dropdown
                            class="float-left"
                            size="sm" variant="link"
                            right text="Right align"
                            toggle-class="text-decoration-none" no-caret>
                            <template #button-content>
                              <i class="fa fa-plus fa-lg"></i>
                            </template>
                            <b-dropdown-item
                              :disabled="!item.idContractor || item.idContractor.isCompany === 0"
                              @click="showCreateCaseModal(threadMessage['@id'])">
                              <i class="fa fa-plus fa-lg"></i>
                              {{ $t('menu.cases.createToMessage') }}
                            </b-dropdown-item>
                          </b-dropdown>
                        </div>
                        <p class="m-0" v-for="(messageCase, messageCaseIndex) in threadMessage.relatedCases" :key="'messageCase' + messageCaseIndex">
                          <router-link v-if="ableToShowCase" :to="{name: 'EXCMCaseShow', params: { id: messageCase['@id'] }}">
                            <span>{{$t('routes.EXCMCaseShow')}} </span>
                            <span v-if="messageCase.number">{{ messageCase.number }}</span>
                            <span v-else>{{ getIdLink(messageCase['@id']) }}</span>
                            <span v-if="messageCase.description"> - {{messageCase.description}}</span>
                          </router-link>
                          <span v-else>
                            <span>{{$t('routes.EXCMCaseShow')}} </span>
                            <span v-if="messageCase.number">{{ messageCase.number }}</span>
                            <span v-else>{{ getIdLink(messageCase['@id']) }}</span>
                            <span v-if="messageCase.description"> - {{messageCase.description}}</span>
                          </span>
                        </p>
                      </b-col>
                    </b-row>
                    <hr>
                  </div>
                  <div class="row">
                    <div class="col">
                      <messageContent :thread-message="threadMessage"/>
                    </div>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-col>
    <updateCorrespondenceThreadRelatedUserDataModal v-if="updateCorrespondenceThread" :update-correspondence-thread="updateCorrespondenceThread" @reset="resetUpdateCorrespondenceThread($event)"/>
    <CreateCaseModal v-if="idRelatedCorrespondenceMessageForCreateCase" :idRelatedCorrespondenceMessage="idRelatedCorrespondenceMessageForCreateCase" :idContractor="item.idContractor['@id']"></CreateCaseModal>
    <CreateNewMessageModal v-if="idSenderTypeForCreateMessage" :idSenderType="idSenderTypeForCreateMessage" :recipient="recipientForCreateMessage"></CreateNewMessageModal>
  </b-row>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import getId from '@/utils/getIdFromLink'
import Loader from '../../Layout/Loader'
import MessageContent from '@/components/Dashboard/Views/excmcorrespondence/MessageContent'
import CreateCaseModal from '@/components/Dashboard/Views/excmcase/modals/CreateCaseModal'
import UpdateCorrespondenceThreadRelatedUserDataModal from '@/components/Dashboard/Views/excmcorrespondence/UpdateCorrespondenceThreadContractorModal'
import { checkPermission } from '@/utils/checkRoles'
import CreateNewMessageModal from '@/components/Dashboard/Views/excmmessage/CreateNewMessageModal.vue'

export default {
  components: {
    CreateNewMessageModal,
    UpdateCorrespondenceThreadRelatedUserDataModal,
    CreateCaseModal,
    MessageContent,
    Loader
  },

  beforeDestroy () {
    this.reset()
  },
  data () {
    return {
      prevRoute: null,
      idRelatedCorrespondenceMessageForCreateCase: null,
      updateCorrespondenceThread: null,
      idSenderTypeForCreateMessage: null,
      recipientForCreateMessage: null
    }
  },
  beforeRouteEnter (to, from, next) {
    next((vm) => {
      vm.prevRoute = from
    })
  },
  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },
  watch: {
    '$route.params' () {
      this.retrieve(decodeURIComponent(this.$route.params.id))
    },
    createdCase () {
      this.idRelatedCorrespondenceMessageForCreateCase = null
      this.retrieve(decodeURIComponent(this.$route.params.id))
    }
  },
  computed: {
    ableToShowCase () {
      return checkPermission('cases', 'EXCMCaseShow')
    },
    ableToCreateCase () {
      return checkPermission('cases', 'EXCMCaseCreate')
    },
    ...mapGetters({
      deleteError: 'excmcorrespondence/del/error',
      error: 'excmcorrespondence/show/error',
      isLoading: 'excmcorrespondence/show/isLoading',
      item: 'excmcorrespondence/show/retrieved',
      createdCase: 'excmcase/create/created'
    }),
    mobileView () {
      return this.$store.state.mobileView
    }
  },
  methods: {
    showCreateCaseModal (idRelatedCorrespondenceMessageForCreateCase) {
      this.idRelatedCorrespondenceMessageForCreateCase = idRelatedCorrespondenceMessageForCreateCase
      this.toggleCreateCaseModal()
    },
    createMessage (recipient, idSenderType) {
      this.recipientForCreateMessage = recipient
      this.idSenderTypeForCreateMessage = idSenderType
      this.toggleCreateMessageModal()
    },
    showSetContractorModal () {
      this.updateCorrespondenceThread = { '@id': this.item['@id'], idContractor: this.item.idContractor ? this.item.idContractor['@id'] : null }
    },
    resetUpdateCorrespondenceThread (withReload = false) {
      this.updateCorrespondenceThread = null
      if (withReload) {
        this.retrieve(decodeURIComponent(this.$route.params.id))
      }
    },
    ...mapMutations({
      toggleCreateCaseModal: 'excmcase/createModal/toggleCreateCaseModal',
      toggleCreateMessageModal: 'excmmessage/createModal/toggleModal'
    }),
    ...mapActions({
      del: 'excmcorrespondence/del/del',
      reset: 'excmcorrespondence/show/reset',
      retrieve: 'excmcorrespondence/show/retrieve'
    }),
    getIdLink (link) {
      return getId(link)
    }
  }
}
</script>
